import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Button } from 'antd'
import { EasyIcon, EditContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const CustomRenderBtn = (props: Props) => {
  const edit = useContext(EditContext)

  if (edit?.dynamicJs[props.config.CLICK_EVENT] instanceof Function) {
    return edit.dynamicJs[props.config.CLICK_EVENT](edit, props)
  }

  const { LABEL, ICON } = props.config
  return <Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='FileTextOutlined' />}>{LABEL}</Button>
}

export default CustomRenderBtn